const getRandomId = () => {
    const returnedIdLength = 7;
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < returnedIdLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export const convertErrors = (errors) => {
    const err = [];
    const id = getRandomId();
    if (typeof errors === 'string') {
        err.push({ type: errors, message: errors, id });
    }
    else if (typeof errors === 'object' && 'error' in errors) {
        err.push({ type: errors.error, message: errors.error, id });
    }
    else if (Array.isArray(errors.errors)) {
        for (const item of errors.errors) {
            err.push({
                ...item,
                id
            });
        }
    }
    return err;
};
